import { formatDate } from "../../../helpers/date";

export const SUPPORT_TICKET_DETAIL_COLUMNS = [
  {
    Header: "Ticket Number",
    id: "support_ticket_number",
    accessor: "support_ticket_number",
    minWidth: 80,
    sortable: false
  },
  {
    Header: "Created On",
    id: "created_on",
    accessor: "created_on",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 80,
    sortable: false
  },
  {
    Header: "Requestor",
    id: "requestor_full_name",
    accessor: "requestor_full_name",
    minWidth: 100,
    sortable: false
  }
];

export const SUPPORT_TICKET_DETAIL_SUB_COLUMNS = [
  {
    Header: "Assigned To",
    accessor: "assigned_to.full_name",
    id: "assigned_to.full_name",
    maxWidth: 250
  },
  {
    Header: "Completed Date",
    id: "completed_date",
    accessor: "completed_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 120
  },
  {
    Header: "Billable Hours",
    accessor: "billable_hrs",
    id: "billable_hrs",
    minWidth: 120
  },
  {
    Header: "Billing Description",
    accessor: "billing_description",
    id: "billing_description",
    minWidth: 120
  }
];
